export default __webpack_public_path__ + "media/color/wicc-a050e9eb.svg";